import math from 'mathjs';
import Parallel  from 'paralleljs';
import {QListCountArray, TwoQListCountArray} from '../component/vectors/canvas'
import {getQuadrant, calculateMagnitude, checkTwoVectorOverlap, overLapSpecialCaseOne, overLapSpecialCaseTwo, overLapSpecialCaseThree, getAngleDeg} from '../component/vectors/vectors'
import { getColorsArrayDisPlayOrder } from "../component/vectors/commonHelpers";
import { DEFAULT_VECTOR_SNAP_TO_GIRD, SymbolType } from '../pages/AssignmentMatrix/Constants';

export const vector_colors = ['#F79722', '#0AAAFA', '#FF5500', '#09B83E', '#34465D', '#E4405F'];

let Quadarant = [];
let Magnitude = [];
let Direction = [];
let CountArr = [];
let ConcatArr = [];

function replaceAll(string, token, newtoken) {
    if (string && token !== newtoken)
        while (string.indexOf(token) > -1) {
            string = string.replace(token, newtoken);
        }
    return string;
}

function getRandomFloatValue(min, max, blackList) {

    if(min === "") min = 0;
    if(max === "") max = 0;

    min = parseFloat(min);
    max = parseFloat(max);

    if (!blackList || blackList.length === 0) {
        return +math.round(math.random(min, max), 1);
    }

    while (true) {
        let value = +math.round(math.random(min, max), 1);
        if (blackList.find(num => parseFloat(num) === value) === undefined) {
            return value;
        }
    }
}

function getRandomInt(
    min,
    max,
    blackList,
) {

    if(min === "") min = 0;
    if(max === "") max = 0;
    
    if(!blackList){
        return math.randomInt(parseInt(min, 10), parseInt(max, 10) + 1);
    } 

    while (true) {
        let value = math.randomInt(parseInt(min, 10), parseInt(max, 10) + 1);
        if (blackList.find((num) => {
                return parseInt(value, 10) === parseInt(num, 10);
            }) === undefined) {
                return value;
        }
    }
}

function getRandomFloat(
    min,
    max,
    blackList
) {

    if(min === "") min = 0;
    if(max === "") max = 0;
    
    if(!blackList){
        return +math.round(math.random(parseFloat(min), parseFloat(max)), 1);
    }

    while (true) {
        let value = +math.round(math.random(parseFloat(min), parseFloat(max)), 1);

        if (blackList.find((num) => {
                return parseFloat(value, 10) === parseFloat(num, 10);
            }) === undefined) {
                return value;
        }
    }
}

function stringToNumberArray(rpBlackList) {
    if (rpBlackList) {
        const arrRpBlackList = [];
        rpBlackList.split(",").forEach(strNum => {
            if (strNum.includes(".") || strNum.includes("e")) {
                arrRpBlackList.push(parseFloat(strNum));
            } else {
                arrRpBlackList.push(parseInt(strNum, 10));
            }
        });

        return arrRpBlackList;
    }

    return [];
}

export class VectorVariable {
    constructor() {
        this.type = undefined;
        this.inputType = 'components';
        this.x = '5';
        this.y = '5';
        this.xMin = '0';
        this.yMin = '0';
        this.xMax = '5';
        this.yMax = '5';
        this.xList = '';
        this.yList = '';
        this.mag = '0';
        this.magnitude = '0';
        this.angle = '0';
        this.ang = '0';
        this.color = '#000000';
        this.direction = '';
        this.angleOptions = {
            angleOffset: 0,
            type: 2,
            clockwise: false
        }
        this.variableType = "RANGE";
        this.posX = '5';
        this.posY = '5';
        this.name = '';
        this.draggable = false;
        this.angleMin = '0';
        this.angleMax = '90';
        this.magMin = '1';
        this.magMax = '5';
        this.gridWidthUnit = "10";
        this.gridHeightUnit = "10";
        this.strokeWidth = 5;
        this.showLegend = false;
        this.showLabel = true;
        this.latexSymbol = SymbolType.IN_PLANE;
        this.zMin = '0';
        this.zMax = '5';
        this.zList = '5';
        this.z = '5';
    }

    static generateValue(variable, height, width, enableIdenticalVectors, vectorSettingsData) {
        const {vectorBlackListX,vectorBlackListY,gridHeightUnit, gridWidthUnit,vectorBlackListAngle,vectorBlackListMagnitude} = variable;
        this.gridWidthUnit =  gridHeightUnit ? gridHeightUnit : height;
        this.gridHeightUnit = gridWidthUnit? gridWidthUnit: width;
        variable.strokeWidth = 5;
        const getRandomIntValue = (value, min, max) => {
            if(value && value != null && value != "") {
                const ArrayList = value.replaceAll(" ", "").split(",").filter((num) => ((num != "" && Number(num) >= Number(min) && Number(num) <= Number(max))));
                const randomIndex = Math.floor(Math.random() * ArrayList.length);
                return ArrayList[randomIndex] ? ArrayList[randomIndex] : "0"; //if xList/yList is invalid default to "0"
            } else {
                return "0";
            }
        }

        const getRandomNumberFromList = (value) => {
            if(value && value != null && value != "") {
                const ArrayList = value.replaceAll(" ", "").split(",").filter((num) => num != "").map(Number);
                const randomIndex = Math.floor(Math.random() * ArrayList.length);
                return ArrayList[randomIndex] ? ArrayList[randomIndex] : "0";
            } else {
                return "0";
            }
        }

        let snapToGrid = DEFAULT_VECTOR_SNAP_TO_GIRD;
        if (vectorSettingsData && vectorSettingsData.isSnapToGridOff !== null && vectorSettingsData.isSnapToGridOff !== undefined) {
            snapToGrid = !vectorSettingsData.isSnapToGridOff;
        }
        console.debug("variable.variableType>>??", variable.variableType)
        switch (variable.inputType) {
            case 'components':
                if (variable.variableType) {
                    if(variable.variableType === "LIST") {
                        variable.x = getRandomIntValue(variable.xList, -(this.gridWidthUnit / 2), (this.gridWidthUnit / 2));
                        variable.y = getRandomIntValue(variable.yList, -(this.gridHeightUnit / 2), (this.gridHeightUnit / 2));
                        variable.z  = getRandomIntValue(variable.zList, -(this.gridHeightUnit / 2), (this.gridHeightUnit / 2));
                    } else {
                        const vectorBlackListXArray = stringToNumberArray(vectorBlackListX);
                        const vectorBlackListYArray = stringToNumberArray(vectorBlackListY);
                        let i = 0;
                        control_start: while(true) {
                            i++;
                            //For avoid system freeze
                            if(i > 20){
                                break;
                            }
                            if (variable.variableType === "RANGE") {
                                variable.z = getRandomInt(variable.zMin,variable.zMax);
                                let count = 0;
                                const maxAttempts = 10;
                                do {
                                    variable.x = getRandomInt(variable.xMin,variable.xMax,vectorBlackListXArray);
                                    variable.y = getRandomInt(variable.yMin,variable.yMax,vectorBlackListYArray);
                                    count++;
                                } while (variable.x === 0 && variable.y === 0 && count < maxAttempts);
                            } else { // RANGE CONTINOUS
                                let count = 0;
                                const maxAttempts = 10;
                                do {
                                    variable.x = getRandomFloatValue(variable.xMin,variable.xMax,vectorBlackListXArray);
                                    variable.y = getRandomFloatValue(variable.yMin,variable.yMax,vectorBlackListYArray);
                                    variable.z = getRandomFloatValue(variable.zMin,variable.zMax, []);
                                    count++;
                                } while (variable.x === 0 && variable.y === 0 && count < maxAttempts);
                            }
                            Quadarant.push(getQuadrant(variable.x, variable.y, variable.posX,variable.posY,variable.gridWidthUnit,variable.gridHeightUnit))
                            Magnitude.push(calculateMagnitude(variable))
                            Direction.push(getAngleDeg(variable))
                            // //Randomize if Question Vector has a Zero Vector
                            // if(Magnitude.some((m)=> m === 0)){
                            //     console.log("Zero Vector Generated. So Randomizing Now..")
                            //     Quadarant.pop();
                            //     Magnitude.pop();
                            //     Direction.pop();
                            //     continue  control_start;
                            // }
                            if(Quadarant.length > 1){
                                CountArr = QListCountArray(Quadarant)
                                ConcatArr = TwoQListCountArray(Magnitude, Direction)
                            }
                            /* We can control vector generation in the same quadrant here.
                            FYI: C>N Where N = Number of times can occur */
                            let checkMorethan3VectorsInQuadrant = CountArr.some((c)=> c>3)
                            let checkTwoVectorsSameMagnitudeDirection = ConcatArr.some((c)=> c>1)  
                            if(checkMorethan3VectorsInQuadrant || (!enableIdenticalVectors && checkTwoVectorsSameMagnitudeDirection)){
                                Quadarant.pop();
                                Magnitude.pop();
                                Direction.pop();
                                CountArr = [];
                                ConcatArr = [];
                                continue  control_start;
                            }
                            break;
                        }
                    }
                    
                }

                break;
            case 'angle-magnitude':

                const vectorBlackListAngleArray = stringToNumberArray(vectorBlackListAngle);
                const vectorBlackListMagnitudeArray = stringToNumberArray(vectorBlackListMagnitude);
                /* const angleVarType = (variable.angleVariableType && variable.angleVariableType !== "")
                    ? variable.angleVariableType
                    : variable.variableType;
                const magVarType = (variable.magVariableType && variable.magVariableType !== "")
                    ? variable.magVariableType
                    : variable.variableType; */
                
                const angleVarType = variable.angleVariableType ? variable.angleVariableType : "INT";
                const magVarType = variable.magVariableType ? variable.magVariableType : "INT";

                // Generate angle based on its own variable type
                if (angleVarType === "FLOAT") {
                    if(variable.angleMax == 0 && variable.angleMax === "") {
                        variable.angle = 0
                    } else {
                        variable.angle = getRandomFloat(parseFloat(variable.angleMin),parseFloat(variable.angleMax),vectorBlackListAngleArray);
                    }
                } else if (angleVarType === "INT") {
                    if(variable.angleMax == 0 && variable.angleMax === "") {
                        variable.angle = 0
                    } else {
                        variable.angle = getRandomInt(parseInt(variable.angleMin),parseInt(variable.angleMax),vectorBlackListAngleArray,snapToGrid);
                    }
                } else if (angleVarType === "LIST") {
                    variable.angle = getRandomNumberFromList(variable.angleList);
                }

                // Generate magnitude based on its own variable type
                if (magVarType === "FLOAT") {
                    if(variable.magMax == 0 && variable.magMax === "") {
                        variable.mag = 0
                    } else {
                        variable.mag = getRandomFloat(parseFloat(variable.magMin),parseFloat(variable.magMax),vectorBlackListMagnitudeArray);
                    }
                } else if (magVarType === "INT") {
                    if(variable.magMax == 0 && variable.magMax === "") {
                        variable.mag = 0
                    } else {
                        variable.mag = getRandomInt(parseInt(variable.magMin),parseInt(variable.magMax),vectorBlackListMagnitudeArray,snapToGrid);
                    }
                } else if (magVarType === "LIST") {
                    variable.mag = getRandomNumberFromList(variable.magList);
                }
                variable.ang = variable.angle
                variable.magnitude = variable.mag
                
                variable.x = Math.cos(variable.angle * (Math.PI / 180)) * parseFloat(variable.mag);
                variable.y = Math.sin(variable.angle * (Math.PI / 180)) * parseFloat(variable.mag);
                break;
            default:
                break;

        }
    }

}



export class VectorVariableMap extends Map {

    containsAll = function (targetMap) {
        if (targetMap && (targetMap instanceof Map)) {
            for (var key of this.keys()) {
                if (!targetMap.has(key))
                    return false;
            }
        } else {
            throw new Error("Method containsAll : argument not of type map")
        }

        return true;
    }

    isValid = function () {


        return true;
    }

    getValidationError = function () {
        let validationError = '';

        return validationError;
    }

    //Validates and Generates Values for the Variables in Map
    //Throws Error if Validation Failes
    generateValues = function (height, width, enableIdenticalVectors, vectorSettingsData) {
        this.forEach(
            (value, key, map) => {

                VectorVariable.generateValue(value,height, width, enableIdenticalVectors, vectorSettingsData);

            }
        );
        Quadarant = [];
        Magnitude = [];
        Direction = [];
        CountArr = [];
        ConcatArr = [];
    }
    
    //For finding vector lengh and sorting based on ascending length 
    getMagnitudeAndSort = function(Arr){
        if(Arr.length > 1){
            let VectorMagArr = [];
            let VectorDirArr = [];
            let VectorArrays = [];
            VectorArrays = [...Arr]
            VectorArrays.forEach((VectorValues) =>{
                VectorMagArr.push(calculateMagnitude(VectorValues)) 
                VectorDirArr.push(getAngleDeg(VectorValues))
            })
            let newMagVectorArr = [];
            newMagVectorArr = [...VectorMagArr]
            // newMagVectorArr = newMagVectorArr.sort().reverse();
            let insideIndex = [];
            let indexes = newMagVectorArr.map((value)=> {
              if(insideIndex.includes(VectorMagArr.indexOf(value))){
                let currentPosition = VectorMagArr.indexOf(value);
                loop_start: while(true) {
                    currentPosition += 1
                    if(insideIndex.includes(VectorMagArr.indexOf(value, currentPosition))) continue loop_start;
                    insideIndex.push(VectorMagArr.indexOf(value, currentPosition))
                    break;
                }
                return VectorMagArr.indexOf(value, currentPosition)
              }
              insideIndex.push(VectorMagArr.indexOf(value))
              return VectorMagArr.indexOf(value)
            })
            let finalVectorArr = indexes.map(value => VectorArrays[value])
            return finalVectorArr;
        }else{
            return Arr;
        }
    }

    //get Vector Array//
    getVectorsArray = function (height, width, enableIdenticalVectors, vectorSettingsData) {
        this.generateValues(height, width, enableIdenticalVectors, vectorSettingsData);
        let generatedSortingVectors = this.getMagnitudeAndSort(Array.from(this.values()));
        return generatedSortingVectors;
    }
}

export default class VectorParserUtil {
    static getVariablesFromText = async(strQuestionText, variablesMap, vectorSettingsData) => {

        
        if (variablesMap === undefined || variablesMap === null) {
            variablesMap = VectorParserUtil.createMap(vectorSettingsData);
        }

        var p = new Parallel(strQuestionText);
        let variableArray = await p.spawn(function (strQuestionText) {
            try {
                /* We're replacing all the img tag src content to empty string because src content has around 1 Lakh characters so checking for vector match takes too long to update the live preview and Vector configuration variable name UI
                Before replacing img tag src content: https://loom.com/i/a200e04f888e458f88c156af6bec1bed
                After replacing img tag src content: https://loom.com/i/a200e04f888e458f88c156af6bec1bed
                */
                strQuestionText = strQuestionText.replace(/<img[^>]+>/g, '');
                let variableArray = strQuestionText.match(/[^[\]]+(?=])/g);
                return variableArray;
            } catch (e) {
                console.log("error -> ", e);
            }
            return variablesMap;
        });
        Array.from(variablesMap.values()).forEach(vectorVariableObj => {
            if (vectorVariableObj.isStandaloneVector) {
                if (variableArray === null || variableArray === undefined) {
                    variableArray = []
                }
                variableArray.push(vectorVariableObj.name);
            }
        })

        const formatValue = (value) => value.toString();

        if (variableArray && variableArray.length > 0) {
            variableArray.forEach((variable, index) => {
                if (!variablesMap.has(variable)) {
                    let gridSettings = vectorSettingsData;
                    let variableObj = new VectorVariable();
                    variableObj.name = variable;
                    // Here we're using the old showLable value in the variableObj
                    Array.from(variablesMap).map(([_,value], mi) => {
                        if (mi === index) {
                            variableObj.showLabel = value.showLabel
                        }
                    })
                    // variableObj.color = getColorsArrayDisPlayOrder(index)
                    if(gridSettings && gridSettings != undefined) {
                        if(variableObj.autoOrigin){
                            variableObj.posX = formatValue(Math.trunc((variableObj.gridWidthUnit / 2) - (variableObj.x/2)));
                            variableObj.posY = formatValue(Math.trunc((variableObj.gridHeightUnit / 2) - (variableObj.y/2)));
                        }else{
                           variableObj.posX = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                           variableObj.posY = formatValue(Math.trunc(gridSettings.heightUnit / 2)); 
                        }
                        variableObj.xMax = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.xMin = formatValue(-Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.yMax = formatValue(Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.yMin = formatValue(-Math.trunc(gridSettings.widthUnit / 2));
                        variableObj.gridWidthUnit = formatValue(gridSettings.widthUnit);
                        variableObj.gridHeightUnit = formatValue(gridSettings.heightUnit);
                    }
                    variablesMap.set(variable, variableObj);
                }

            });
            for (var key of variablesMap.keys()) {
                if (!variableArray.includes(key))
                    variablesMap.delete(key);
            }
            return variablesMap;
        }
        
        return variablesMap;
    }

    static createDefaultVectorVariableMap (variablesMap, vectorSettingsData, lastVariable) {
        // If variablesMap is not provided, create it using the vector settings data
        if (variablesMap === undefined || variablesMap === null) {
            variablesMap =  new VectorVariableMap();
        }
        let variableName;
    
        if (lastVariable === "") {
            variableName = 'A';
        } else {
            // Increment the last variable character
            variableName = String.fromCharCode(lastVariable.charCodeAt(0) + 1);
        }
    
        
        // Create a new VectorVariable with default settings
        let variableObj = new VectorVariable();
        variableObj.name ="\\vec{" + variableName + "}";  // Use the dynamic variable name
        
        // Default values based on vector settings
        variableObj.color = getColorsArrayDisPlayOrder(variablesMap.size);  // Assign color based on map size (for uniqueness)
        // variableObj.posX = Math.trunc(vectorSettingsData.widthUnit / 2);  // Default X position
        // variableObj.posY = Math.trunc(vectorSettingsData.heightUnit / 2);  // Default Y position
        // variableObj.xMax = Math.trunc(vectorSettingsData.widthUnit / 2);  // Max X
        // variableObj.xMin = -Math.trunc(vectorSettingsData.widthUnit / 2);  // Min X
        // variableObj.yMax = Math.trunc(vectorSettingsData.heightUnit / 2);  // Max Y
        // variableObj.yMin = -Math.trunc(vectorSettingsData.heightUnit / 2);  // Min Y
        variableObj.gridWidthUnit = vectorSettingsData.widthUnit;  // Grid width
        variableObj.gridHeightUnit = vectorSettingsData.heightUnit;  // Grid height
    
        // Add the dynamic variable to the map
        variablesMap.set(variableName, variableObj);
    
        return variablesMap;
    };


    static createDefaultVectorVariable(vectorSettingsData, lastVariable) {

        const nextLetter = (ch) => {
            if (ch === 'Z') return 'A';
            if (ch === 'z') return 'a';
            return String.fromCharCode(ch.charCodeAt(0) + 1);
        }

        let variableName;
        if (lastVariable === "") {
            variableName = 'A';
        } else {
            // Increment the last variable character
            // variableName = String.fromCharCode(lastVariable.charCodeAt(0) + 1);
            variableName = nextLetter(lastVariable);
        }
    
        
        // Create a new VectorVariable with default settings
        let variableObj = new VectorVariable();
        variableObj.name ="\\vec{" + variableName + "}";  // Use the dynamic variable name

        // variableObj.posX = Math.trunc(vectorSettingsData.widthUnit / 2);  // Default X position
        // variableObj.posY = Math.trunc(vectorSettingsData.heightUnit / 2);  // Default Y position
        // variableObj.xMax = Math.trunc(vectorSettingsData.widthUnit / 2);  // Max X
        // variableObj.xMin = -Math.trunc(vectorSettingsData.widthUnit / 2);  // Min X
        // variableObj.yMax = Math.trunc(vectorSettingsData.heightUnit / 2);  // Max Y
        // variableObj.yMin = -Math.trunc(vectorSettingsData.heightUnit / 2);  // Min Y

        variableObj.posX = "5";  // Default X position
        variableObj.posY =  "5";  // Default Y position
        variableObj.xMax =  "5";  // Max X
        variableObj.xMin = "0";  // Min X
        variableObj.yMax =  "5";  // Max Y
        variableObj.yMin = "0";  // Min Y
        variableObj.zMax =  "5";  // Max Y
        variableObj.zMin = "0";  // Min Y

        variableObj.gridWidthUnit = vectorSettingsData.widthUnit;  // Grid width
        variableObj.gridHeightUnit = vectorSettingsData.heightUnit;  // Grid height
        return variableObj;
    };

    //Creates a Map and Adds custom helper functions before returing
    static createMap() {
        return new VectorVariableMap();
    }

    static getAnswerFormulasArrayFromText = (strAnswerText) => {
        return strAnswerText.match(/[^[\]]+(?=])/g);
    }

    static computeFormula = (formulaString, variablesMap, suffix='') => {
        let localStrQuestionText = formulaString;


        if (variablesMap === undefined || variablesMap === null) {
            return 0;
        }


        for (var key of variablesMap.keys()) {
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_x`, variablesMap.get(key)[`x${suffix}`]);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_y`, variablesMap.get(key)[`y${suffix}`]);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_z`, variablesMap.get(key)[`z${suffix}`]);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_angle`, variablesMap.get(key)[`angle${suffix}`]);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_magnitude`, variablesMap.get(key)[`mag${suffix}`]);

            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_ang`, variablesMap.get(key)[`angle${suffix}`]);
            localStrQuestionText = replaceAll(localStrQuestionText, `${key}_mag`, variablesMap.get(key)[`mag${suffix}`]);

        }
        try {
            return math.eval(localStrQuestionText);
        } catch { 
            return 0;
        }

    }

    //TODO:
    static generateAnswerVector = (vectorAnswerFormula, variablesMap, suffix, vectorSettingsData) => {
        if (!vectorAnswerFormula || !variablesMap) {
            return null
        }
        let answerVector = new VectorVariable();
        const {
            angleFormula,
            formulaType,
            formulaColor,
            magFormula,
            name,
            xFormula,
            yFormula,
            showLabel,
            showLegend,
            showImage,
            showComponents,
            showAngle,
            xOrigin,
            yOrigin,
            autoOrigin,

        } = vectorAnswerFormula;
        answerVector.name = name;
        answerVector.type = formulaType;
        if (formulaColor && formulaColor !== null && formulaColor !== "") {
            answerVector.color = formulaColor;
        }
        switch (formulaType) {
            case 'components': {
                answerVector.x = VectorParserUtil.computeFormula(xFormula, variablesMap, suffix)
                answerVector.y = VectorParserUtil.computeFormula(yFormula, variablesMap, suffix)
                break;
            }
            case 'angle-magnitude': {
                answerVector.angle = VectorParserUtil.computeFormula(angleFormula, variablesMap, suffix)
                answerVector.mag = VectorParserUtil.computeFormula(magFormula, variablesMap, suffix)
                answerVector.ang = answerVector.angle
                answerVector.magnitude = answerVector.mag
                answerVector.x = VectorParserUtil.computeFormula(magFormula, variablesMap, suffix)
                answerVector.y = VectorParserUtil.computeFormula(angleFormula, variablesMap, suffix)
                break;
            }
            default:
                break
        }

        answerVector["showLabel"] = showLabel;
        answerVector["showImage"] = showImage;
        answerVector["showComponents"] = showComponents;
        answerVector["showAngle"] = showAngle;
        answerVector["showLegend"] = showAngle;
        if(vectorSettingsData) {
            const gridwidth = parseInt((vectorSettingsData.width / vectorSettingsData.stepSize),10);
            const gridheight = parseInt((vectorSettingsData.height / vectorSettingsData.stepSize),10);

            const xorigin = (gridwidth/2 - answerVector.x/2).toFixed(0);
            const yorigin = (gridheight/2 - answerVector.y/2).toFixed(0);
            answerVector["gridWidthUnit"] = (gridwidth).toString();
            answerVector["gridHeightUnit"] = (gridheight).toString();
            if(autoOrigin){
                answerVector["posX"] = xorigin;
                answerVector["posY"] = yorigin;
            }else{
                answerVector["posX"] = xOrigin;
                answerVector["posY"] = yOrigin;
            }
            //console.log("Answer Vector Origin =", answerVector["posX"],",",answerVector["posY"])
        } else {
            answerVector["posX"] = vectorAnswerFormula.posX;
            answerVector["posY"] = vectorAnswerFormula.posY;
        }
        return answerVector;
    }

    static buildQuestionVariablesMap(variablesArray, vectorSettingsData){
        let variablesMap  =  VectorParserUtil.createMap(vectorSettingsData);
        if(variablesArray){
            variablesArray.forEach(variable => {
                variablesMap.set(variable.name,variable);
         });
        }
        return variablesMap;
      }

      
    static isAnswerCorrect(vector_answer_formula, selectedAnswer, currentVectorVariable) {
        const correctAnswerVector = VectorParserUtil.generateAnswerVector(vector_answer_formula, currentVectorVariable);
        return correctAnswerVector.x === selectedAnswer.x && correctAnswerVector.y === selectedAnswer.y;
    }

    static shouldRandomize(answerFormulaArr, gridWidthUnit,gridHeightUnit){
        let magArr = [];
        let DirArr = [];
        let countArr = [];

        for(let index=0;index<answerFormulaArr.length; index++){
            let answer = answerFormulaArr[index];
            if(answer){
                if(answer && answer.hasOwnProperty('x') && answer.hasOwnProperty('y')){ 
                    magArr.push(calculateMagnitude({...answer, gridWidthUnit,gridHeightUnit})) 
                    DirArr.push(getAngleDeg({...answer, gridWidthUnit,gridHeightUnit}))  
                } 
            }
        }

        if(magArr.length > 1){
            magArr = magArr.filter((mag)=> mag !== null)
            DirArr = DirArr.filter((dir)=> dir !== null)
            countArr = TwoQListCountArray(magArr,DirArr)
        }

        for(let ix = 0; ix < countArr.length; ix++){
            if(countArr[ix]> 1){
                    return true;
            }
        }

        return false;
    }
    static checkAnswerFormula(answerFormulaArr){

        let xFormulaArr = [];
        let yFormulaArr = [];
        let magFormulaArr = [];
        let angleFormulaArr = [];

        for(let index=0;index<answerFormulaArr.length; index++){
            let answer = answerFormulaArr[index];
            if(answer){
                const {vectorAnswerFormula: answerV} = answer;
                if(answerV && answerV.formulaType && answerV.formulaType === "components" && answerV.xFormula && answerV.yFormula){
                    if(answerV.xFormula !== "" && answerV.yFormula !== ""){
                        if(index === 0){
                            xFormulaArr.push(answerV.xFormula.trim())
                            yFormulaArr.push(answerV.yFormula.trim())
                        }
            
                        if(index > 0){
                            const trimX = answerV.xFormula.trim();
                            if(xFormulaArr.includes(trimX)){
                                xFormulaArr.push(trimX)
                                const trimY = answerV.yFormula.trim();
                                if(yFormulaArr.includes(trimY)){
                                    let prevIndex = yFormulaArr.indexOf(trimY)
                                    return `The answer formula for Answer-${prevIndex+1} is identical to Answer-${index+1}. Please make sure to have a unique formula for each answer.`;
                                }else{
                                    yFormulaArr.push(trimY)
                                }
                            }else{
                                xFormulaArr.push(trimX)
                            }
                        }
        
                    }
                }else if(answerV && answerV.formulaType && answerV.formulaType === "angle-magnitude" && answerV.magFormula && answerV.angleFormula){
                    if(answerV.magFormula !== "" && answerV.angleFormula !== ""){
                        if(index === 0){
                            magFormulaArr.push(answerV.magFormula.trim())
                            angleFormulaArr.push(answerV.angleFormula.trim())
                        }
            
                        if(index > 0){
                            const trimMag = answerV.magFormula.trim();
                            if(magFormulaArr.includes(trimMag)){
                                magFormulaArr.push(trimMag)
                                const trimAng = answerV.angleFormula.trim();
                                if(angleFormulaArr.includes(trimAng)){
                                    let prevIndex = angleFormulaArr.indexOf(trimAng)
                                    return `The answer formula for Answer-${prevIndex+1} is identical to Answer-${index+1}. Please make sure to have a unique formula for each answer.`;
                                }else{
                                    angleFormulaArr.push(trimAng)
                                }
                            }else{
                                magFormulaArr.push(trimMag)
                            }
                        }
        
                    }

                } 
            }
        }

        return undefined
    }

    static testAnswerBounds({vectorAnswerFormula},{widthUnit,heightUnit},vectorsMap){
        const gridwidth = parseInt(widthUnit,10);
        const gridheight = parseInt(heightUnit,10);
        const maxBoundVector = VectorParserUtil.generateAnswerVector(vectorAnswerFormula,vectorsMap,"Max")
        const minBoundVector = VectorParserUtil.generateAnswerVector(vectorAnswerFormula,vectorsMap,"Min")
        
        if(!minBoundVector || !maxBoundVector){
            return "invalid Answer formula"
        }
        
        /*

        -gridwidth <= xans <= gridtwidth

        -gridheight<= yans <= gridtheight
        */
        let LableX = "X";
        let LableY = "Y";
        if(vectorAnswerFormula.formulaType === "angle-magnitude") {
            LableX = "magnitude";
            LableY = "angle";
        }
        //console.log(vectorAnswerFormula.posX,",",vectorAnswerFormula.posY, "minX =", minBoundVector.x,"maxX =",maxBoundVector.x, "minY =", minBoundVector.y,"maxY =",maxBoundVector.y )
        if(-gridwidth > minBoundVector.x || minBoundVector.x > gridwidth){
            return `The vector goes outside the grid for ${LableX} value ${minBoundVector.x}`;
        }

        if(-gridheight > minBoundVector.y || minBoundVector.y > gridheight){
            return `The vector goes outside the grid for ${LableY} value ${minBoundVector.y}`;
        }

        if(-gridwidth > maxBoundVector.x || maxBoundVector.x > gridwidth){
            return `The vector goes outside the grid for ${LableX} value ${minBoundVector.x}`;
        }

        if(-gridheight > maxBoundVector.y || maxBoundVector.y > gridheight){
            return `The vector goes outside the grid for ${LableY} value ${minBoundVector.y}`;
        }
        return "";
    }

    static validateAnswerVariables({vectorAnswerFormula}, vectorsMap){
        
        let finalXString = vectorAnswerFormula.xFormula;
        let finalYString = vectorAnswerFormula.yFormula;
        
        if(vectorAnswerFormula.formulaType === "angle-magnitude") {
            finalXString = vectorAnswerFormula.magFormula;
            finalYString = vectorAnswerFormula.angleFormula;
        }

        for (var key of vectorsMap.keys()) {
            finalYString = replaceAll(finalYString, `${key}_y`, '');
            finalXString = replaceAll(finalXString, `${key}_x`, '');
        }

        const reg = /[0-9&\/\\#,+()$~%.'":*?]/g;
        finalXString = finalXString.replaceAll(reg, "");
        finalYString = finalYString.replaceAll(reg, "");

        finalXString = finalXString.split(" ");
        finalYString = finalYString.split(" ");

        if(vectorAnswerFormula.formulaType === "angle-magnitude") {
            for (let index = 0; index < finalXString.length; index++) {
                const arrayValue = finalXString[index];
                
                if(arrayValue != "" && arrayValue.indexOf("_x") > 0) {
                    return `${vectorAnswerFormula.name} has an invalid vector value “${arrayValue}” in the magFormula field`;
                }
            }

            for (let index = 0; index < finalYString.length; index++) {
                const arrayValue = finalYString[index];
                
                if(arrayValue != "" && arrayValue.indexOf("_y") > 0) {
                    return `${vectorAnswerFormula.name} has an invalid vector value “${arrayValue}” in the angleFormula field`;
                }
            }
        } else {
            for (let index = 0; index < finalXString.length; index++) {
                const arrayValue = finalXString[index];
                
                if(arrayValue != "" && arrayValue.indexOf("_x") > 0) {
                    return `${vectorAnswerFormula.name} has an invalid vector value “${arrayValue}” in the xFormula field`;
                }
            }
            
            for (let index = 0; index < finalYString.length; index++) {
                const arrayValue = finalYString[index];
                
                if(arrayValue != "" && arrayValue.indexOf("_y") > 0) {
                    return `${vectorAnswerFormula.name} has an invalid vector value “${arrayValue}” in the yFormula field`;
                }
            }
        }

        return "";
    }
}